import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { DateTimeToNormalDate } from "../../../../custom/DateTimeToNormalDate";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import TextWrap from "../../../../custom/TextWrap";
import { useNavigate } from "react-router-dom";

const ProductCards = ({ reviewData, dummy_user, loadMoreData, hasMore }) => {
  const navigate = useNavigate();

  const handleNavigateProduct = (productId) => {
    if (productId) {
      navigate(`/app/product-details/${productId}`);
    }
  };

  // ── Empty state for admin panel ────────────────────────────────────────
  if (!reviewData || reviewData.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center min-h-[500px] bg-gray-50/40 rounded-xl border border-dashed border-gray-300">
        <div className="mb-6 text-gray-400">
          <svg
            className="w-20 h-20 mx-auto"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>

        <h3 className="text-xl font-semibold text-gray-700 mb-2">
          No Product Reviews Yet
        </h3>

        <p className="text-gray-500 max-w-md mb-8">
          No products have been reviewed by this customer.
        </p>

        {/* <div className="flex items-center gap-1 text-amber-300 mb-6">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} className="text-2xl opacity-40" />
          ))}
        </div> */}
      </div>
    );
  }

  return (
    <div className="divide-y divide-gray-200">
      {reviewData.map((item) => {
        const rating = Number(item?.rating) || 0;
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        const productId = item?.product_detail?._id;
        const productName = item?.product_detail?.name || "Unnamed Product";

        return (
          <div
            key={item._id || `${productId}-${item.updatedAt}`}
            className="flex gap-5 p-5 hover:bg-gray-50/60 transition-colors"
          >
            {/* Product Image */}
            <div className="flex-shrink-0">
              <LazyLoadImage
                src={item?.images?.[0] || dummy_user}
                alt={productName}
                effect="blur"
                wrapperProps={{ style: { transitionDelay: "0.4s" } }}
                className="h-20 w-20 object-cover rounded-lg shadow-sm border border-gray-200"
              />
            </div>

            {/* Main content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h4
                    className="font-semibold text-gray-800 hover:text-blue-600 cursor-pointer transition-colors"
                    onClick={() => handleNavigateProduct(productId)}
                  >
                    {productName}
                  </h4>

                  <div className="mt-1 flex items-center gap-3 text-sm text-gray-600">
                    <span>
                      by{" "}
                      <span className="font-medium capitalize">
                        {item?.user?.first_name} {item?.user?.last_name || ""}
                      </span>
                    </span>
                    <span>•</span>
                    <time>{DateTimeToNormalDate(item?.updatedAt)}</time>
                  </div>
                </div>

                {/* Rating - aligned right */}
                <div className="flex items-center gap-1.5 whitespace-nowrap">
                  <div className="flex">
                    {[...Array(fullStars)].map((_, i) => (
                      <FaStar
                        key={`f-${i}`}
                        className="text-amber-500 text-lg"
                      />
                    ))}
                    {hasHalfStar && (
                      <FaStarHalfAlt className="text-amber-500 text-lg" />
                    )}
                    {[...Array(emptyStars)].map((_, i) => (
                      <FaRegStar
                        key={`e-${i}`}
                        className="text-gray-300 text-lg"
                      />
                    ))}
                  </div>
                  <span className="text-sm font-medium text-gray-700 ml-1">
                    {rating.toFixed(1)}
                  </span>
                </div>
              </div>

              {/* Review text */}
              <p className="mt-3 text-gray-700 leading-relaxed">
                {TextWrap(item?.review || "— No comment provided —", 180)}
              </p>
            </div>
          </div>
        );
      })}

      {hasMore && hasMore > reviewData.length && (
        <div className="p-6 text-center border-t">
          <button
            onClick={loadMoreData}
            className="px-8 py-2.5 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-400 transition font-medium text-gray-700"
          >
            Load More Reviews
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductCards;